import React, { useContext, useEffect, useState } from 'react';
import axiosConfig from '../../../utils/axiosConfig';
// import { useTheme } from '@material-ui/core/styles';
// import clsx from 'clsx';

import { Box, Button, Grid, Paper, Typography } from '@material-ui/core';
import { Assignment as AssignmentIcon, EventNote as EventNoteIcon } from '@material-ui/icons';

import ResponsiveLayout from '../../Layouts/ResponsiveLayout';
import SchoolListItem from '../../../components/Master/Dashboard/SchoolListItem/SchoolListItem';
import { StateContext, DispatchContext } from '../../../context/Provider';

const Dashboard = () => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { authState, globalState } = appState;
    const { globalDispatch } = appDispatch;

    const [isMounted, setIsMounted] = useState(true);
    const [totalSchools, setTotalSchools] = useState('');
    const [totalUsers, setTotalUsers] = useState('');
    const [totalStudents, setTotalStudents] = useState('');

    async function fetchTotalStats() {

        try {

            const response = await axiosConfig.get(`/getStatCounts`);
            const { totalSchools, totalUsers, totalStudents } = response.data.data;

            if (isMounted) {
                setTotalSchools(totalSchools);
                setTotalUsers(totalUsers);
                setTotalStudents(totalStudents);
            }

        } catch(e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    useEffect(() => {

        globalDispatch({type: 'setIsLoading', value: true});
        const source = axiosConfig.CancelToken.source();
        fetchTotalStats();

        return () => {
            source.cancel();
        }

    }, []);

    return (
        <ResponsiveLayout>
            {/* <Box mb={3}>
                <Button size="small" color="inherit" style={{textTransform: 'none', marginRight: 5}}>
                    <AssignmentIcon color="action" fontSize="small" style={{paddingRight: 2}} />To-do
                </Button>
                <Button size="small" color="inherit" style={{textTransform: 'none'}}>
                    <EventNoteIcon color="action" fontSize="small" style={{paddingRight: 2}} />Calendar
                </Button>
            </Box> */}
            {/* <Grid container spacing={2}>
                <Typography variant="h6">Dashboard</Typography>
            </Grid> */}

            <Box mb={2}>
                <Typography variant="h6">
                    Dashboard
                </Typography>
            </Box>

            { !globalState.isLoading && (
                <Grid container spacing={2}>
                    { authState.user.role_id === 1 && (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                            <Paper elevation={2}>
                                <Box p={3} style={{textAlign: 'center'}}>
                                    <Typography variant="h4">{totalSchools}</Typography>
                                    <Box pt={1}>
                                        <Typography>Schools</Typography>
                                    </Box>
                                </Box>
                            </Paper>
                        </Grid>
                    )}

                    <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                        <Paper elevation={2}>
                            <Box p={3} style={{textAlign: 'center'}}>
                                <Typography variant="h4">{totalUsers}</Typography>
                                <Box pt={1}>
                                    <Typography>Users</Typography>
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                        <Paper elevation={2}>
                            <Box p={3} style={{textAlign: 'center'}}>
                                <Typography variant="h4">{totalStudents}</Typography>
                                <Box pt={1}>
                                    <Typography>Students</Typography>
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            )}

        </ResponsiveLayout>
    );

}

export default Dashboard;